import axios from 'axios'
import { toLowerCaseKeys } from '../utils'

export const BACKEND_ENVIRONMENT_STORAGE_KEY = 'backendEnvironment'

export enum BackendEnvironmentTypes {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
}

export interface BackendConfiguration {
  projectApi: string
  functionBlockCommandApi: string
  functionBlockQueryApi: string
  resourceApi: string
  controlStateHub: string
  releaseStateHub: string
  comissioningStateHub: string
  chartQueryApi: string
  consumptionQueryApi: string
  consumptionCommandApi: string
  alarmStateHub: string
  plcStateHub: string
  logHub: string
  energyStatusHub: string
  kioskHub: string
  eunomiaApi: string
  plcOperationQueryApi: string
  plcOperationCommandApi: string
  plcConfigurationQueryApi: string
  plcConfigurationCommandApi: string
  systemConfigurationQueryApi: string
  systemConfigurationCommandApi: string
  userSettingsApi: string
}

export const BackendEnvironmentConfiguration = {
  [BackendEnvironmentTypes.DEVELOPMENT]: {
    projectApi: 'https://projectapi.development.ecocoa.ch',
    functionBlockCommandApi: 'https://functionblockcommandapi.development.ecocoa.ch',
    functionBlockQueryApi: 'https://functionblockqueryapi.development.ecocoa.ch',
    resourceApi: 'https://resourceapi.development.ecocoa.ch',
    controlStateHub: 'https://pushqueryapi.development.ecocoa.ch/ControlStateHub',
    releaseStateHub: 'https://pushqueryapi.development.ecocoa.ch/ReleaseStateHub',
    comissioningStateHub: 'https://pushqueryapi.development.ecocoa.ch/CommissioningStateHub',
    chartQueryApi: 'https://chartqueryapi.development.ecocoa.ch',
    consumptionQueryApi: 'https://consumptionqueryapi.development.ecocoa.ch',
    consumptionCommandApi: 'https://consumptioncommandapi.development.ecocoa.ch',
    alarmStateHub: 'https://pushqueryapi.development.ecocoa.ch/AlarmStateHub',
    plcStateHub: 'https://pushqueryapi.development.ecocoa.ch/plcStateHub',
    logHub: 'https://pushqueryapi.development.ecocoa.ch/logHub',
    energyStatusHub: 'https://pushqueryapi.development.ecocoa.ch/energyStatusHub',
    kioskHub: 'https://pushqueryapi.development.ecocoa.ch/kioskHub',
    eunomiaApi: 'https://eunomia.development.ecocoa.ch',
    plcOperationCommandApi: 'https://plcoperationcommandapi.development.ecocoa.ch',
    plcOperationQueryApi: 'https://plcoperationqueryapi.development.ecocoa.ch',
    plcConfigurationQueryApi: 'https://plcconfigurationqueryapi.development.ecocoa.ch',
    plcConfigurationCommandApi: 'https://plcconfigurationcommandapi.development.ecocoa.ch',
    systemConfigurationQueryApi: 'https://systemconfigurationqueryapi.development.ecocoa.ch',
    systemConfigurationCommandApi: 'https://systemconfigurationcommandapi.development.ecocoa.ch',
    userSettingsApi: 'https://usersettingsapi.development.ecocoa.ch',
  } as BackendConfiguration,
  [BackendEnvironmentTypes.STAGING]: {
    projectApi: 'https://projectapi.staging.ecocoa.ch',
    functionBlockCommandApi: 'https://functionblockcommandapi.staging.ecocoa.ch',
    functionBlockQueryApi: 'https://functionblockqueryapi.staging.ecocoa.ch',
    resourceApi: 'https://resourceapi.staging.ecocoa.ch',
    controlStateHub: 'https://pushqueryapi.staging.ecocoa.ch/ControlStateHub',
    releaseStateHub: 'https://pushqueryapi.staging.ecocoa.ch/ReleaseStateHub',
    comissioningStateHub: 'https://pushqueryapi.staging.ecocoa.ch/CommissioningStateHub',
    chartQueryApi: 'https://chartqueryapi.staging.ecocoa.ch',
    consumptionQueryApi: 'https://consumptionqueryapi.staging.ecocoa.ch',
    consumptionCommandApi: 'https://consumptioncommandapi.staging.ecocoa.ch',
    alarmStateHub: 'https://pushqueryapi.staging.ecocoa.ch/AlarmStateHub',
    plcStateHub: 'https://pushqueryapi.staging.ecocoa.ch/plcStateHub',
    logHub: 'https://pushqueryapi.staging.ecocoa.ch/logHub',
    energyStatusHub: 'https://pushqueryapi.staging.ecocoa.ch/energyStatusHub',
    kioskHub: 'https://pushqueryapi.staging.ecocoa.ch/kioskHub',
    eunomiaApi: 'https://eunomia.staging.ecocoa.ch',
    plcOperationCommandApi: 'https://plcoperationcommandapi.staging.ecocoa.ch',
    plcOperationQueryApi: 'https://plcoperationqueryapi.staging.ecocoa.ch',
    plcConfigurationQueryApi: 'https://plcconfigurationqueryapi.staging.ecocoa.ch',
    plcConfigurationCommandApi: 'https://plcconfigurationcommandapi.staging.ecocoa.ch',
    systemConfigurationQueryApi: 'https://systemconfigurationqueryapi.staging.ecocoa.ch',
    systemConfigurationCommandApi: 'https://systemconfigurationcommandapi.staging.ecocoa.ch',
    userSettingsApi: 'https://usersettingsapi.staging.ecocoa.ch',
  } as BackendConfiguration,
  [BackendEnvironmentTypes.PRODUCTION]: {
    projectApi: 'https://projectapi.production.ecocoa.ch',
    functionBlockCommandApi: 'https://functionblockcommandapi.production.ecocoa.ch',
    functionBlockQueryApi: 'https://functionblockqueryapi.production.ecocoa.ch',
    resourceApi: 'https://resourceapi.production.ecocoa.ch',
    controlStateHub: 'https://pushqueryapi.production.ecocoa.ch/ControlStateHub',
    releaseStateHub: 'https://pushqueryapi.production.ecocoa.ch/ReleaseStateHub',
    comissioningStateHub: 'https://pushqueryapi.production.ecocoa.ch/CommissioningStateHub',
    chartQueryApi: 'https://chartqueryapi.production.ecocoa.ch',
    consumptionQueryApi: 'https://consumptionqueryapi.production.ecocoa.ch',
    consumptionCommandApi: 'https://consumptioncommandapi.production.ecocoa.ch',
    alarmStateHub: 'https://pushqueryapi.production.ecocoa.ch/AlarmStateHub',
    plcStateHub: 'https://pushqueryapi.production.ecocoa.ch/plcStateHub',
    logHub: 'https://pushqueryapi.production.ecocoa.ch/logHub',
    energyStatusHub: 'https://pushqueryapi.production.ecocoa.ch/energyStatusHub',
    kioskHub: 'https://pushqueryapi.production.ecocoa.ch/kioskHub',
    eunomiaApi: 'https://eunomia.production.ecocoa.ch',
    plcOperationCommandApi: 'https://plcoperationcommandapi.production.ecocoa.ch',
    plcOperationQueryApi: 'https://plcoperationqueryapi.production.ecocoa.ch',
    plcConfigurationQueryApi: 'https://plcconfigurationqueryapi.production.ecocoa.ch',
    plcConfigurationCommandApi: 'https://plcconfigurationcommandapi.production.ecocoa.ch',
    systemConfigurationQueryApi: 'https://systemconfigurationqueryapi.production.ecocoa.ch',
    systemConfigurationCommandApi: 'https://systemconfigurationcommandapi.production.ecocoa.ch',
    userSettingsApi: 'https://usersettingsapi.production.ecocoa.ch',
  } as BackendConfiguration,
}

export const StatusCode = {
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  InternalServerError: 500,
}

export interface ApiServiceOptions {
  appId: string
  environment: string
}

const ApiService = {
  _environment: '',
  _appId: '',
  _401interceptor: -99,
  _errorInterceptor: null as (number | null),

  init(options: ApiServiceOptions) {
    this._appId = options.appId
    this._environment = options.environment
  },
  selectedBackendEnvironment(): string {
    return this._environment
  },
  backendEnvironmentConfiguration(): BackendConfiguration {
    return BackendEnvironmentConfiguration[this.selectedBackendEnvironment() || 'production']
  },
  registerUnauthorizedHandler(handler: (() => void)) {
    if (this._401interceptor !== null) {
      // unregister maybe already registered handler
      axios.interceptors.request.eject(this._401interceptor)
    }
    this._401interceptor = axios.interceptors.response.use((response) => {
      return response
    }, (error) => {
      if (error.response && error.response.status === StatusCode.Unauthorized) {
        handler()
      }
      return Promise.reject(error)
    })
  },
  registerErrorHandler(handler: ((errorContext: { statusCode?: number, payload?: any }) => void)) {
    if (this._errorInterceptor !== null) {
      // unregister maybe already registered handler
      axios.interceptors.request.eject(this._errorInterceptor)
    }
    this._errorInterceptor = axios.interceptors.response.use((response) => {
      return response
    }, async (error) => {
      const statusCode = error.response && error.response.status
      if (statusCode !== StatusCode.Unauthorized) { // don't handle unauthorized, it is handled by the 401interceptor
        // in case of blob and text requests, try to parse the response body as object
        const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json'
        const responseData = isJsonBlob(error.response?.data) ? await (error.response?.data)?.text() : error.response?.data || {}
        const responseJson = (typeof responseData === 'string') ? JSON.parse(responseData) : responseData
        const payload = typeof responseJson === 'object' ? toLowerCaseKeys(responseJson) : {}
        handler({ statusCode, payload })
      }
      return Promise.reject(error)
    })
  },
  setHeader(token: string) {
    // tslint:disable:no-string-literal
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.common['Accept'] = 'application/json application/text'
    axios.defaults.headers.common['Content-Type'] = 'application/json application/json-patch+json'
  },

  removeHeader() {
    axios.defaults.headers.common = {}
  },

  get(url, options?: { responseType?: 'blob' }) {
    return options ? axios.get(url, options) : axios.get(url)
  },

  post(url, data) {
    return axios.post(url, data)
  },

  put(url, data) {
    return axios.put(url, data)
  },

  delete(url, data) {
    return axios.delete(url, data)
  },
}
export default ApiService